import { appConfig } from '../../../config/customization';
import { modalPadding } from '../../../constants/sizes';
import Device from '../../../constants/deviceSizes';
import { iconTitle } from '../../../constants/fonts';

const footerSize = 80;
const headerSize = 50;

const contentStyle = {
  backgroundColor: appConfig.colors.white,
  borderRadius: appConfig.UTModal.modalBorderRadius,
  outline: 'none',
  zIndex: 11,
  padding: 0,
  transform: 'translate(-50%,-50%)',
  left: '50%',
  top: '50%',
  right: 'auto'
};

export default {
  contentForm: {
    ...contentStyle,
    position: 'fixed',
    bottom: 'auto',
    minWidth: '20rem',
    maxWidth: '30rem',
    maxHeight: '85vh',
    border: 0,
    overflow: 'hidden'
  },
  contentImage: {
    ...contentStyle,
    display: 'table',
    overflow: 'hidden',
    outline: 'none',
    fontSize: 0 // This line if for unwanted margin at bottom due to display: table
  },

  overlayStyle: {
    backgroundColor: appConfig.colors.modalOverlayColor,
    zIndex: 10
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
    justifyContent: 'flex-start',
    overflow: 'auto',
    borderRadius: appConfig.UTModal.modalBorderRadius
  },
  content: {
    flex: '1 0 auto',
    maxHeight: `calc(85vh - ${headerSize}px - ${footerSize}px)`,
    overflowY: 'auto'
  },
  footer: {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: footerSize,
    paddingRight: modalPadding,
    paddingLeft: modalPadding
  },
  title: {
    [Device.tablet_mobile]: {
      fontSize: iconTitle
    }
  }
};
